/* eslint-disable react/jsx-props-no-spreading */
import * as types from "_graphql-types-frontend/graphql";
import { Select } from "../../../Select/Select";
import { useCallback, useContext } from "react";
import { useCurrentUser } from "../../../../utils/hooks";
import { useFieldValue } from "../../Context/hooks";
import { FieldStamp } from "../FieldAuditStamp";
import FieldSuggestionChip from "../FieldSuggestionChip.component";
import { useTemplateController } from "../FieldContext";
import { InputFieldProps } from "./InputFieldBase";
import { useShallow } from "zustand/react/shallow";

const { Option } = Select;

export const OPTIONS = new Map([
  [null, ""],
  ["true", "Yes"],
  ["false", "No"],
  ["N/A", "N/A"],
]);

export default function BooleanDropdownNaFieldInput({
  templateKey,
  metadata,
  templateOverride,
  formLookupKey,
  NotApplicableWrapper,
}: InputFieldProps): JSX.Element {
  const questionText = templateOverride?.questionText || metadata.questionText;

  const {
    flags: { isRockCreek },
  } = useCurrentUser();

  const {
    field: { onChange, ...inputProps },
  } = useTemplateController({
    name: formLookupKey,
  });

  const { field: managerData } = useFieldValue(
    templateKey,
    types.FieldState.Mgr
  );

  const handleChange = useCallback(
    (value: string | null) => onChange(value),
    [onChange]
  );

  const handleApplySuggestion = useCallback(
    (suggested: unknown) => {
      // Worker returns "true" / "false" / "N/A" strings.
      const next = String(suggested ?? "");
      handleChange(OPTIONS.has(next) ? next : null);
    },
    [handleChange]
  );

  return (
    <NotApplicableWrapper {...{ templateKey, metadata }}>
      <>
        {!!questionText && (
          <div
            data-cy="template__textarea"
            data-test-id="template__textarea"
            className={"main-input__info"}
          >
            <div className="main-input__sublabel">{questionText}</div>
          </div>
        )}
        <Select
          {...inputProps}
          style={{ marginRight: "20px", maxWidth: "100px" }}
          className="main-select"
          popupClassName="main-select__menu"
          onChange={handleChange}
          value={inputProps.value}
        >
          {[...OPTIONS].map(([value, label]) => (
            <Option key={value} value={value as unknown as string} title={label}>
              {label}
            </Option>
          ))}
        </Select>
        <FieldSuggestionChip
          templateKey={templateKey}
          hideMultiStateView={metadata.value.hideMultiStateView}
          onApply={handleApplySuggestion}
          formatValue={v => OPTIONS.get(String(v)) ?? String(v)}
        />
        {typeof managerData?.value === "string" && isRockCreek && (
          <div className="rating-txt">
            Manager Entry: {OPTIONS.get(managerData.value)}.
            <div className="d-flex flex-wrap">
              <FieldStamp field={managerData} />
              <button
                onClick={() => handleChange(managerData.value)}
                type="button"
                className="in-blue-500"
              >
                <span> Move to draft </span>
              </button>
            </div>
          </div>
        )}
      </>
    </NotApplicableWrapper>
  );
}
